export default "__VITE_ASSET__CWyObcm$__"